export type OrderBy<TColumn extends string> = `${TColumn}${'' | '_desc'}`;

class SortOrder<TColumn extends string> {
  constructor(public readonly column: TColumn, public readonly isAscending: boolean = true) {}

  public toString = (): OrderBy<TColumn> => `${this.column}${this.isAscending ? '' : '_desc'}`;
}

export default SortOrder;
